import { Member } from 'common/modules/ReactShared';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  INavigationItem,
  assignmentsItem,
  boardsItem,
  homeItem,
  // catalogItem,
  learningMaterialsItem,
  // meetingsItem,
  liveClassesItem,
  studyPlanItem,
  testsItem
} from '../config';
import { useHasStudyPlan } from './useHasStudyPlan';

function useNavBarItems(): Array<INavigationItem> {
  const meetingsStore = useSelector(Member.selectors.selectMeetingsStore);
  const hasStudyPlan = useHasStudyPlan();
  const hasMeetings = meetingsStore.meetings.length > 0;
  const boardsStore = useSelector(Member.selectors.selectBoardsStore);
  const assignmentsStore = useSelector(
    Member.Assignments.selectors?.selectTab('pending_action')
  );
  const testsStore = useSelector(Member.Tests.selectors.selectTab('pending'));
  return useMemo(() => {
    const result = [homeItem];

    if (hasStudyPlan) result.push(studyPlanItem);
    if (hasMeetings) result.push(liveClassesItem);

    result.push({
      ...assignmentsItem,
      badgeCount: assignmentsStore.totalCount ?? 0
    });

    result.push({
      ...testsItem,
      badgeCount: testsStore?.totalCount ?? 0
    });

    // result.push(catalogItem);
    result.push(learningMaterialsItem);

    result.push({
      ...boardsItem,
      badgeCount:
        boardsStore.boards.reduce((acc, curr) => acc + (curr.newBoard ? 1 : 0), 0) ?? 0
    });

    return result;
  }, [
    hasStudyPlan,
    hasMeetings,
    assignmentsStore?.totalCount,
    testsStore?.totalCount,
    boardsStore.boards
  ]);
}

export default useNavBarItems;
